import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        loaded: false,
        hostUrl: '',
    },
    mutations: {
        loading(state) {
            state.loaded = true;
        },
        showing(state) {
            state.loaded = false;
        },
        saveHost(state, host) {
            state.hostUrl = host;
        },
    },
    getters: {
        getLoaded(state) {
            return state.loaded;
        },
    },
})


// WEBPACK FOOTER //
// ./src/utils/store.js